/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable no-restricted-globals */
import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { RouteComponentProps } from 'react-router-dom';
import server from '../../_api/backend';
import * as toast from '../../_store/slice/toast';

export function Cart(props: RouteComponentProps) {
  const dispatch = useDispatch();
  const [booksCount, setBooksCount] = useState<number>(0);
  const [booksPrice, setBooksPrice] = useState<number>(0);
  const [totalPrice, setTotalPrice] = useState<number>(0);
  const [items, setItems] = useState<any[]>([]);
  const [beyandDf, setBeyandDf] = useState<number>(0);
  const [stpayDf, setStpayDf] = useState<number>(0);
  const [stpayDf1, setStpayDf1] = useState<number>(0);
  const [shippingPrice, setShippingPrice] = useState<number>(0);

  useEffect(() => {
    if (window.localStorage.getItem('token') !== null) {
      getCart();
    } else {
      props.history.push('/login');
    }
  }, []);

  useEffect(() => {
    if (window.localStorage.getItem('token') !== null) {
      getShippingPrice();
    }
  }, [items]);

  // 장바구니 조회 API 호출
  const getCart = async () => {
    await server
      .getCart()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setItems(payload.items);
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 장바구니 아이템 상세보기 이동
  const onClickBookDetail = (bookCode: any) => {
    props.history.push(`/books/${bookCode}`);
  };

  // 장바구니 아이템 제거 API 호출
  const onClickRemove = async (id: any) => {
    await server
      .deleteCart(id)
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        }
        getCart();
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
  };

  // 주문하기 버튼 클릭 시
  const onClickOrder = () => {
    if (booksCount === 0) {
      dispatch(toast.error({ message: '장바구니가 비었습니다' }));
      return;
    }
    props.history.push('/orders');
  };

  // 배송관리(배송비) 조회 API 호출
  const getShippingPrice = async () => {
    await server
      .getDelivery()
      .then((payload) => {
        if (!payload) {
          dispatch(toast.error({ message: '서버로부터 응답이 없습니다.' }));
        } else if (payload.code === 260 || payload.code === 500) {
          dispatch(toast.error({ message: '파라미터 오류' }));
        } else {
          setBeyandDf(parseInt(payload[0].beyandDf, 10));
          setStpayDf(parseInt(payload[0].stpayDf, 10));
          setStpayDf1(parseInt(payload[0].stpayDf1, 10));
        }
      })
      .catch((error) => {
        dispatch(toast.error({ message: '서버 접속이 원활하지 않아 잠시 뒤에 시도해 주세요.' }));
        console.log(error);
      });
    const sumPrice = items.reduce((sum: number, book: any) => {
      sum += Number(book.bookPrice) * Number(book.bookqty);
      return sum;
    }, 0);
    const sumQty = items.reduce((sum: number, book: any) => {
      sum += Number(book.bookqty);
      return sum;
    }, 0);
    setBooksCount(Number(sumQty));
    setBooksPrice(Number(sumPrice));
    if (Number(sumPrice) < Number(stpayDf)) {
      setShippingPrice(Number(beyandDf));
      setTotalPrice(Number(sumPrice) + Number(beyandDf));
    } else {
      setShippingPrice(Number(stpayDf1));
      setTotalPrice(Number(sumPrice) + Number(stpayDf1));
    }
  };

  // Cart 리턴값
  return (
    <main className="sub shoppingbag wrapper">
      <div className="content">
        <div className="breadscrumb">
          <>Home</>
          {' > '}
          <>장바구니</>
        </div>
        <div className="title">
          <h2>장바구니</h2>
          <p>고객님의 장바구니입니다.</p>
        </div>
        <section className="list">
          <div className="table">
            {items.map((item: any) => {
              return (
                <ul className="row" key={item.id}>
                  <li className="thumbnail">
                    <img src={item.bookImage} />
                  </li>
                  <li
                    className="book-title"
                    onClick={() => {
                      onClickBookDetail(`${item.bookCode}`);
                    }}
                  >
                    {item.bookName}
                  </li>
                  <li className="quantity">{Number(item.bookqty).toLocaleString()}</li>
                  <li className="price">{Number(item.bookPrice).toLocaleString()}</li>
                  <li
                    className="buttons"
                    onClick={() => {
                      onClickRemove(`${item.id}`);
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path d="M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z" />
                    </svg>
                  </li>
                </ul>
              );
            })}
          </div>
          <div className="order-container">
            <h3>전체상품: {Number(booksCount)}개</h3>
            <ul className="total">
              <li>
                <span>주문금액</span>
                <span className="price">{booksPrice.toLocaleString()}</span>
              </li>
              <li>
                <span>배송비</span>
                <span className="price">+ {shippingPrice.toLocaleString()}</span>
              </li>
              <li>
                <span>결제하실 금액</span>
                <span className="price">{totalPrice.toLocaleString()}</span>
              </li>
            </ul>
            <div className="buttons">
              <button type="button" className="btn-main" onClick={onClickOrder}>
                주문하기
              </button>
            </div>
          </div>
        </section>
      </div>
    </main>
  );
}
